<template>
  <div class="expandable-content-button">
    <button @click="showContent = !showContent" type="button" :class="styles">
      <i :class="showContent?hideIcon:icon"></i>
      <span>{{ showContent?hideText:text }}</span>
    </button>
    <slot v-if="showContent"></slot>
  </div>
</template>

<script>
export default {
  props: {
    styles: {
      type: Object,
      required: false,
      default: function() {
        return {
          "btn-primary": true,
          "btn--block": true,
          "btn--text": true
        };
      }
    },
    icon: {
      type: String,
      required: false,
      default: "fa fa-eye"
    },
    hideIcon: {
      type: String,
      required: false,
      default: "fa fa-eye-slash"
    },
    hideText: {
      type: String,
      required: false,
      default: ""
    },
    shown: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: String,
      required: false,
      default: ""
    }
  },
  data: function() {
    return {
      showContent: this.shown
    };
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/ExpandableContentButton.vue